import { Component, OnInit } from '@angular/core';
import { IonSlides } from '@ionic/angular';
import { ViewChild } from '@angular/core'
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-introduction',
  templateUrl: './introduction.page.html',
  styleUrls: ['./introduction.page.scss'],
})
export class IntroductionPage implements OnInit {

  constructor(private navController: NavController) { }


  slideIndex = 0;

  ngOnInit() {
  }

  navigateToAddressInput() {
    this.navController.navigateForward(`/address`);
  }

  @ViewChild('slides', { static: true }) slides: IonSlides; slideOpts = {
    initialSlide: 1,
    speed: 400,
    pager: true
  };

  swipeNext(){
    this.slides.slideNext();
    this.slides.getActiveIndex().then((index)=> {
      this.slideIndex = index;
    })
  }

  swipePrev() {
    this.slides.slidePrev();
    this.slides.getActiveIndex().then((index)=> {
      this.slideIndex = index;
      
    })
  }

  slideChanged(e: any) {
    this.slides.getActiveIndex().then((index) => {
      this.slideIndex = index;
    });
  }

}
